import React, { PureComponent } from 'react';
import './styles.scss';
import {  ACTIONS } from './../../../../actions/admin-user';
import { connect } from "react-redux";
import Loading from '../../../../components/loading';

class AdminUserDelete extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			id : null,
			showLoading : false,
			idUser: '',
		}
	}

	UNSAFE_componentWillMount = () => {
		this.setState({
			id : this.props.id
		})
	}

	deleteUser = () => {
		this.props.returnActionDelete(this.state.id);
		this.props.onClose();
	}

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		this.setState({
			idUser: nextProps.email
		})
		if (nextProps.type === ACTIONS.DELETE_ADMIN_USERS_SUCCESS) {
			this.setState({ 
				showLoading : false,
			});
			this.props.onClose();
		}
	}

	componentDidMount = () => {
        this.commonHideComponent('delete', 'modal-delete-user');
    }

    commonHideComponent = (p, c) => {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        if (wrapWorkspace) {
            
        let self = this;
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                self.props.onClose();
            }
		});
		}
	}

	render() {
		// eslint-disable-next-line react/prop-types
		const { onClose } = this.props;
		return (
			<div className="modal-custom" id="delete">
				<div className="modal">
					<div className="modal-content" id="modal-delete-user">
						<div className="modal-header">
							<span className="modal-title">ユーザーの削除</span>
						</div>
						<div className="modal-body">
							<p className="message-confirm">このユーザーを削除します。本当によろしいですか？</p>
							<p className="info-message">ログインID :  { this.state.idUser }</p>
						</div>
						<div className="modal-footer">
							<button type="button" className="" onClick={onClose}>キャンセル</button>
							<button type="button" className="" onClick={() => this.deleteUser()}>削除</button>
						</div>
					</div>
				</div>
				<Loading show={this.state.showLoading} />
			</div>
		);
	}
}

const mapStateToProps = ({ adminUsers }) => {
    return {
		type : adminUsers.type
    }
}

const mapDispatchToProps = dispatch => {
    return {
        
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(AdminUserDelete);